module.exports = require("./ga.js");